<template lang="pug">
  .g-cont
    .label
      span {{ this.title }}
    .gradient-ring(@click="src ? $refs.avatar.click() : $refs.logo.click()")
      .pic-cont
        .image(v-if="src" :style="src && `background: url(${src}) no-repeat center / cover`")
          input.hide(type="file" name="avatar" ref="avatar" accept="image/png, image/jpeg, image/jpg" capture @change="handleFileUpload")
        .no-image(v-else)
          vm-icon(icon="image-outline" color="rgb(183, 183, 183)" size="3rem")
          input.hide(type="file" name="logo" ref="logo" accept="image/png, image/jpeg, image/jpg" capture @change="handleFileUpload")
      .plus-button
        vm-icon.add-icon(icon="plus-outline" color="white" size="1.4rem")
</template>

<script>
import axios from 'axios'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('Users')

export default {
  name: 'profile-image',
  data: () => ({
    uploadPercentage: 0
  }),
  props: {
    src: {
      type: String
    },
    title: {
      type: String
    },
    url: {
      type: String
    }
  },
  methods: {
    ...mapActions([
      'alertMessage'
    ]),
    async handleFileUpload ({ target }) {
      let type = target.files[0].type
      let file = target.files[0]
      this.submitImage(file, type)
    },
    async submitImage (file, type) {
      let formData = new FormData()
      formData.append('file', file)
      formData.append('type', type)

      try {
        const res = await axios.post(this.url,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: progressEvent => {
              this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
            }
          }
        )
        this.$emit('response', res.data)
        this.alertMessage()
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.image {
    height: 150px;
    object-fit: cover;
}
.no-image {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
.plus-button {
    background: #2980b9;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 3px solid white;
    z-index: 3;
    position: absolute;
    right: 0;
    bottom: 0;
    transform:scale(1) rotate(0deg);
    transition: all .5s cubic-bezier(1.000, -0.360, 0.000, 1.385); /* custom */
    transition-timing-function: cubic-bezier(1.000, -0.360, 0.000, 1.385);
}
.pic-cont:hover ~ .plus-button {
  transform:scale(1.1) rotate(360deg);
}
.g-cont {
    height: 150px;
    width: 150px;
    position: relative;
    cursor: pointer;
    user-select: none;
}
.gradient-ring {
    height: 100%;
    width: 100%;
    border-radius: 50%;
    border: double 4px transparent;
    border-radius: 80px;
    background-image: linear-gradient(white, white), radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%);
    background-origin: border-box;
    background-clip: content-box, border-box;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}
.pic-cont {
    overflow: hidden;
    background: #e4e4e4;
    border-radius: 50%;
    height: 90%;
    width: 90%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 2;
    transition: all 0.1s ease-in;
}
.pic-cont:hover {
  filter: brightness(80%);
  transform: scale(1.03);
}
.hide {
  display: none;
}
.label {
  width: 100px;
  font-size: 10px;
  z-index: 900;
  background: rgb(51, 51, 51);
  color: white;
  position: fixed;
  border-radius: 4px;
  padding: 5px;
  display: none;
}
.g-cont:hover {
  .label {
    display: flex !important;
  }
}
</style>
